<div>
  <nx-pageTitle-box
    [label]="'API-Key' + (this.id ? ' bearbeiten' : ' anlegen')"
    [bcRootLvlLabel]="'Developer'"
    [bcRootLvlPath]="'settings/developer'"
    [icon]="'icon-api'"
    [iconToolTip]="">
    </nx-pageTitle-box>
<div class="body flex flex-col white">
  <div [formGroup]="apiKeyFormGroup" class="flex flex-col gap-25">
    <mat-form-field class="basis-full">
      <mat-label>Kommentar</mat-label>
      <input matInput formControlName="comment">
    </mat-form-field>
  </div>
  <div class="basis-full flex flex-row gap-25 justify-end items-start">
    <button mat-flat-button (click)="saveApiKey()" id="save" color="primary"
      [disabled]="!(apiKeyFormGroup?.valid)">Speichern</button>
      <button mat-flat-button (click)="abort()" id="cancel" color="primary">Abbrechen</button>
  </div>
</div>

<ng-template #APIDialog>
  <span class="dialog-close" mat-dialog-close>
    <mat-icon>close</mat-icon>
  </span>
  <h2 mat-dialog-title>API-Key erstellt</h2>
  <mat-dialog-content class="flex flex-col">
    <div class="p-4">
      Es wurde ein neuer API-Key erstellt:
      <div class="p-5">
        <b>API Key-ID:</b>&nbsp; &nbsp;{{newId}}<i [cdkCopyToClipboard]="newId" class="api-icon icon-copy">
        </i><br />
        <b>API Key:</b>&nbsp; &nbsp; &nbsp; &nbsp; {{newKey}}<i [cdkCopyToClipboard]="newKey" class="api-icon icon-copy">
        </i><br />
      </div>
      Der API-Key wird nur einmal angezeigt und kann nicht wiederhergestellt werden.
      <br /> Bitte speichere ihn an einem sicheren Ort ab. Bei Verlust muss ein neuer API-Key erstellt werden.
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-flat-button matDialogClose="yes" color="primary">Schliessen</button>
  </mat-dialog-actions>
</ng-template>

